import { useCallback } from 'react';

interface QueryParamActions {
  get: (key: string) => string | null;
  remove: (...keys: string[]) => void;
}

export function useQueryParams(): QueryParamActions {
  const get = useCallback((key: string): string | null => {
    if (typeof window === 'undefined') return null;
    return new URLSearchParams(window.location.search).get(key);
  }, []);

  const remove = useCallback((...keys: string[]): void => {
    if (typeof window === 'undefined') return;
    const params = new URLSearchParams(window.location.search);
    keys.forEach((key) => params.delete(key));
    const newSearch = params.toString();
    const cleanUrl =
      window.location.pathname +
      (newSearch ? `?${newSearch}` : '') +
      window.location.hash;
    window.history.replaceState({}, '', cleanUrl);
  }, []);

  return { get, remove };
}
